module.exports = __webpack_public_path__ + "img/genre02.adf3df18.jpg";